/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/8
 */
export const SWITCH_PAGE = 'SWITCH_PAGE';
export const ADD_DIALOG = 'ADD_DIALOG';
export const DESTROY_DIALOG = 'DESTROY_DIALOG';
export const SET_IS_LOADING = 'SET_IS_LOADING';

let dialogId = 1;

export const switchPage = page => {
  return {
    type: SWITCH_PAGE,
    page
  }
};

export const addDialog = (msg='网络开小差') => {
  const id = `${new Date()}-${dialogId++}`;
  return {
    type: ADD_DIALOG,
    data: {
      id,
      msg
    }
  }
}

export const destroyDialog = id => ({
  type: DESTROY_DIALOG,
  id
});

export const setisLoading = isLoading => ({
  type: SET_IS_LOADING,
  isLoading
})


// WEBPACK FOOTER //
// ./src/actions/app.js